import React from 'react';
import {max} from 'd3-array';
import {scaleLinear} from 'd3-scale';
import {line, area} from 'd3-shape';

import YearXAxis from './YearXAxis';
import YearYAxis from './YearYAxis';

const YearGraph = ({active_neighborhood, formatters, active_mode, active_year, browser_width}) => {

  let svg_width = 360;
  if (browser_width < 451) svg_width = browser_width;
  const svg_height = 200;

  const margins = {
    top: 20,
    right: 60,
    bottom: 30,
    left: 40
  }

  const inner_width = svg_width - margins.left - margins.right;
  const inner_height = svg_height - margins.top - margins.bottom;

  const years = [2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018];

  const x = scaleLinear()
    .domain([years[0], years[years.length - 1]])
    .range([0, inner_width])

  let y = false;
  let y_value = false;
  let test_dots = false;

  // Price graph stuff
  if (active_mode === 'Price') {
    const price_max = max(active_neighborhood.year_prices);
    const year_index = years.indexOf(active_year);
    const samples_year_max = active_neighborhood.samples.map((year_samples) => max(year_samples));
    const samples_max = Math.ceil(max(samples_year_max)/100000) * 100000 + 200000;

    y = scaleLinear()
      .domain([0, 8000000])
      .range([inner_height, 0])


    let liner = line()
      .x((d, i) => x(years[i] + 0.5))
      .y((d) => y(d))
    let main_line = liner(active_neighborhood.year_prices);

    let arear = area()
      .x((d, i) => x(years[i] + 0.5))
      .y0((d) => y(d[0]))
      .y1((d) => y(d[2]))

    let main_area = arear(active_neighborhood.year_all_prices);

    test_dots = <g>
      <path
        d={main_area}
        fill="#ccc"
      />
      <path
        d={main_line}
        stroke="#222"
        fill="transparent"
        strokeWidth="1"
      />
      <line
        x1={x(active_year + 0.5)}
        x2={x(active_year + 0.5)}
        y1="0"
        y2={inner_height}
        stroke="#666"
        strokeWidth="1"
        strokeDasharray="2,2"
      />
    </g>
  } else {
    y = scaleLinear()
      .domain([0, 1])
      .range([inner_height, 0])

    test_dots = active_neighborhood.year_probabilities.map((probability,i) => {
      let fill = '#ccc';
      if (years[i] === active_year) {
        fill = '#666';
      }
      return <rect
        key={years[i]}
        x={x(years[i] + 0.225)}
        y={y(probability)}
        width={x(2010.6)}
        height={inner_height - y(probability)}
        fill={fill}
      />
    })

  }



  return (
    <div className=""
      style={{
        height: svg_height
      }}
    >
      <svg
        style={{
          width: svg_width,
          height: svg_height,
        }}
      >
        <defs>
          <clipPath id="clipPath">
            <rect x="0" y="0" width={inner_width + 40} height={inner_height} />
          </clipPath>
        </defs>
        <g transform={`translate(${margins.left},${margins.top})`}>
          <rect
            x="0"
            y="0"
            width={inner_width + 40}
            height={inner_height}
            fill="#fafafa"
          />
          <YearXAxis
            x={x}
            formatters={formatters}
            inner_height={inner_height}
            svg_height={svg_height}
            margins={margins}
          />
          <YearYAxis
            y={y}
            formatters={formatters}
            svg_width={svg_width}
            margins={margins}
            active_mode={active_mode}
          />
          <g
            style={{
              clipPath: 'url(#clipPath)'
            }}
          >
            {test_dots}
          </g>
        </g>
      </svg>
    </div>
  )
}

export default YearGraph;



/** WEBPACK FOOTER **
 ** ./src/components/YearGraph.js
 **/